import { Highlightable } from '@angular/cdk/a11y';
import { Directive, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';

export interface ItemSelectionEvent<T> {
  source: AutocompleteOptionDirective<T>;
}

@Directive({
  selector: '[ttItem]',
  standalone: true,
})
export class AutocompleteOptionDirective<T> implements Highlightable {
  @HostBinding('class.tt-item') ttItem = true;

  private _active = false;
  set active(value: boolean) {
    this._active = value;
  }
  @HostBinding('class.tt-item--active') get active() {
    return this._active;
  }

  @Input() value: T;

  private _disabled = false;
  @Input()
  set disabled(value: boolean) {
    this._disabled = value;
  }
  get disabled() {
    return this._disabled;
  }

  @Output() selected = new EventEmitter<ItemSelectionEvent<T>>();

  getLabel(): string {
    throw new Error('Method not implemented.');
  }

  public setActiveStyles(): void {
    this.active = true;
  }

  public setInactiveStyles(): void {
    this.active = false;
  }

  public deselect(): void {
    this.active = false;
  }

  @HostBinding('attr.aria-selected')
  get isSelected() {
    return this._active;
  }

  @HostBinding('class.cmdk-item-disabled')
  get itemDisabled() {
    return this.disabled;
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown($event: MouseEvent): void {
    $event.preventDefault();
  }

  @HostListener('click', ['$event'])
  onClick($event: MouseEvent): void {
    $event.stopPropagation();
    this.selected.emit({ source: this });
  }
}
